import React, { useState } from "react";
import {
  Badge,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  TagLabel,
  Select,
  TableContainer,
  Button,
} from "@chakra-ui/react";
import useReportData from "../../../hooks/useReportData";

const RegulatoryTimelineWidget = ({ funds }) => {
  const { upcomingDeadlines } = useReportData(funds);

  // State for the selected timeframe and report type
  const [timeframe, setTimeframe] = useState(1); // Default to 1 month
  const [selectedCategory, setSelectedCategory] = useState("All"); // Default to "All"

  // Get unique report categories without 'Report.pdf'
  const categories = [
    "All",
    ...new Set(
      upcomingDeadlines.map((d) => d.name.replace(" Report.pdf", ""))
    ),
  ];

  // Get the current date and the date `timeframe` months from now
  const now = new Date();
  const futureDate = new Date();
  futureDate.setMonth(futureDate.getMonth() + timeframe);

  // Filter deadlines based on timeframe and selected category
  const filteredDeadlines = upcomingDeadlines.filter((deadline) => {
    const deadlineDate = new Date(deadline.deadline);
    const matchesTimeframe =
      deadlineDate < now || (deadlineDate >= now && deadlineDate <= futureDate);
    const matchesCategory =
      selectedCategory === "All" ||
      deadline.name.replace(" Report.pdf", "") === selectedCategory;

    return matchesTimeframe && matchesCategory;
  });

  return (
    <Flex flex={1} direction="column" w={"100%"}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <h5>Regulatory Deadlines</h5>
        <Flex gap={2}>
          <Select
            width="fit-content"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {categories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </Select>
          
          <Select
            width="fit-content"
            value={timeframe}
            onChange={(e) => setTimeframe(Number(e.target.value))}
          >
            <option value={1}>Next month</option>
            <option value={2}>Next 2 months</option>
            <option value={3}>Next 3 months</option>
          </Select>
         
        </Flex>
      </Flex>

      <TableContainer w={"100%"}>
        <Table variant="simple" size="sm" w={"100%"} tableLayout="fixed">
          <Thead>
            <Tr>
              <Th>Report Name</Th>
              <Th>Fund Name</Th>
              <Th>Next Deadline</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredDeadlines.map((deadline, index) => (
              <Tr key={index}>
                <Td fontWeight="bold" isTruncated maxWidth="150px">
                  {deadline.name.replace(" Report.pdf", "")}
                </Td>
                <Td>
                  <Tag colorScheme="brand">
                    <TagLabel>{deadline.fundName}</TagLabel>
                  </Tag>
                </Td>
                <Td>
                  <Badge
                    colorScheme={
                      new Date(deadline.deadline) < now ? "red" : "green"
                    }
                  >
                    {new Date(deadline.deadline).toLocaleDateString()}
                  </Badge>
                </Td>
                <Td>
                  <Button
                    size="xs"
                    colorScheme="brand"
                    variant={"outline"}
                    onClick={() =>
                      alert(`Generating report for ${deadline.name}`)
                    }
                  >
                    Generate
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Flex>
  );
};

export default RegulatoryTimelineWidget;
